/**
 * CTRIP-P2 · 携程建档 API · 真契约源 apps/api-server/src/api_server/routes/ctrip_listings.py
 * 只做多日游；一日游预检直接 422「一日游走携程玩乐」。
 */
import { api } from "./api";
import type { CtripListingStatus } from "./types/channelCenter";

export interface CtripMissing {
  group: "product" | "lookup" | "profile";
  field: string;
  label: string;
  detail: string;
  fix_link: string | null;
}

export interface CtripPackage {
  name: string;
  code: string;          // 基础套餐为空串
  adult_sale: number;    // 美元（元）
  adult_cost: number;
  child_sale: number;
  child_cost: number;
}

export interface CtripPrecheck {
  option_id: string;
  option_code: string;
  ready: boolean;
  missing: CtripMissing[];
  warnings: string[];
  packages: CtripPackage[];
  inventory_days: number;
}

export interface CtripPush {
  kind: "price" | "inventory" | "selling" | "listing";
  summary: string;
  at: string | null;
  result: "ok" | "failed";
}

export interface CtripListingDetail {
  option_id: string;
  option_code: string;
  status: CtripListingStatus;
  ctrip_product_code: number | null;
  /** CTRIP-P3 · 手工绑定 vbooking 产品的两个编码；bound = 已绑定且在推 */
  vendor_product_code: string | null;
  vendor_package_code: string | null;
  bound: boolean;
  /** 自动建档开关（租户设置，默认关）：关着时不显示「提交到携程审核」 */
  auto_listing_enabled: boolean;
  submitted_at: string | null;
  audit: { type: string; result: string; reject_reason: string | null; days: string | null } | null;
  content_stale: boolean;
  last_price_push_at: string | null;
  last_inventory_push_at: string | null;
  recent_pushes: CtripPush[];
}

const BASE = "/api/v1/ctrip/listings";

export const CTRIP_LISTING_KEY = ["ctrip-listing"] as const;

export const precheckCtripListing = (optionId: string) => api<CtripPrecheck>(`${BASE}/${optionId}/precheck`);
export const getCtripListing = (optionId: string) => api<CtripListingDetail>(`${BASE}/${optionId}`);
export const submitCtripListing = (optionId: string) => api<{ status: string; ctrip_product_code: number | null }>(`${BASE}/${optionId}:submit`, { method: "POST" });
export const resubmitCtripListing = (optionId: string) => api<{ status: string; ctrip_product_code: number | null }>(`${BASE}/${optionId}:resubmit`, { method: "POST" });
export interface CtripBindBody { vendor_product_code: string; vendor_package_code: string; ctrip_product_id?: number }
export const bindCtripListing = (optionId: string, body: CtripBindBody) =>
  api<{ status: string; vendor_product_code: string; vendor_package_code: string }>(`${BASE}/${optionId}:bind`, { method: "POST", body: JSON.stringify(body) });
export const unbindCtripListing = (optionId: string) => api<{ status: string }>(`${BASE}/${optionId}:unbind`, { method: "POST", body: "{}" });
export const offlineCtripListing = (optionId: string) => api<{ status: string; ctrip_product_code: number | null }>(`${BASE}/${optionId}:offline`, { method: "POST" });

/** 后端错误体 ``{detail: {message, step?, missing?}}`` → 给人看的一句话（携程原话原样带出） */
export function ctripErrorMessage(e: unknown): string {
  const d = (e as { detail?: { detail?: { message?: string } } })?.detail?.detail;
  return d?.message ?? (e as Error)?.message ?? "操作失败";
}
